// extracted by mini-css-extract-plugin
export var actions = "_t1-4";
export var item = "_t1-1";
export var price = "_t1-3";
export var quantity = "_t1-2";
export var table = "_t1-0";